import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getConfig } from 'utils';

// POST login -> { status, message, userId, fullName, tokentimeout, accessToken: "Bearer ..." }
// Wrong credentials -> HTTP 401 { status: 401, message: "Login Failed" }
export const signIn = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'login',
            data: {
                "username": data?.username,
                "password": data?.password
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

// Login Via Phone No. (portal #/mobile-verification)
// 1) POST subscriber/generateOtpForCustomersLogin { mobile } -> data { nonce }
const phonePost = async (path, data) => {
    try {
        return await axios({ method: "post", url: getConfig.API_URL + path, data, headers: { "Content-Type": "application/json" } })
    } catch (error) {
        return error.response
    }
}
export const phoneLoginSendOtp = createAsyncThunk('PhoneLoginSendOtp', async ({ mobile }) =>
    phonePost('subscriber/generateOtpForCustomersLogin', { "mobile": mobile }))

// 2) POST subscriber/verifyOtpForCustomersAtLogin { mobile, mobileotp, nonce } -> dataList [{ userId, fullName, nonce }]
export const phoneLoginVerifyOtp = createAsyncThunk('PhoneLoginVerifyOtp', async ({ mobile, otp, nonce }) =>
    phonePost('subscriber/verifyOtpForCustomersAtLogin', { "mobile": mobile, "mobileotp": otp, "nonce": nonce }))

// 3) "Login As": POST subscriber/generateTokenAfterLoginVerification { nonce, userid } -> data { status, accessToken, userId }
export const phoneLoginSelectUser = createAsyncThunk('PhoneLoginSelectUser', async ({ userId, nonce }) =>
    phonePost('subscriber/generateTokenAfterLoginVerification', { "nonce": nonce, "userid": userId }))

// Forgot password step 1: OTP is mailed to the registered email.
// responseCode 200 => sent, 404 => responseMessage (e.g. user not found)
export const forgotPasswordSendOtp = createAsyncThunk('ForgotPasswordSendOtp', async ({ username }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'subscriber/forgotPassword',
            data: { username },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

// Step 2: responseCode 200 => data.ROTP (needed for step 3), 417 => Invalid OTP
export const forgotPasswordVerifyOtp = createAsyncThunk('ForgotPasswordVerifyOtp', async ({ username, otp }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'subscriber/validateForgotPassword',
            data: { username, otp },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

// Step 3: payload keys exactly as the portal sends them
export const forgotPasswordReset = createAsyncThunk('ForgotPasswordReset', async ({ newpassword, username, rtop }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'subscriber/self/updatePassword',
            data: { newpassword, username, rtop },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const signInSlice = createSlice({
    name: 'signIn',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(signIn.fulfilled, (state, action) => {
            if (action?.payload?.status === 200 && action?.payload?.data?.status === 200) {
                state.data = action.payload.data;
            } else {
                state.data = null;
            }
        });
        builder.addCase(signIn.rejected, (state, action) => {
            state.data = null;
        })
    }
})

export default signInSlice.reducer;
